import React from "react";
import {
    TextField,
    Grid,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const gridStyleNoHeight = { padding: "0px 10px", marginTop: "15px" };
const gridStyle = { height: 75, padding: "0px 10px" };

const StepContainer = ({ title, children }) => {
    return (
        <Grid container item xs={12} justify="center">
            <Grid container item sm={12} md={10}>
                <Typography className="whiteText" style={{ fontSize: 20, width: '100%', padding: '0px 10px' }}>
                    {title}
                </Typography>
                <Grid container item alignItems="center" justify="space-between" xs={12} style={{ paddingTop: 10 }}>
                    {children}
                </Grid>
            </Grid>
        </Grid>
    )
}

const Header = (props) => {
    const {
        trainingList,
        formData,
        isCreate,
        setFormValue,
    } = props;

    return (
        <StepContainer title={getLocalizedString("indicateProfileParameters")}>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                <TextField
                    disabled={!isCreate}
                    required
                    fullWidth
                    margin={"none"}
                    label={getLocalizedString("profileCodeAlt")}
                    value={formData.code}
                    inputProps={{ maxLength: 20 }}
                    onChange={(e) => setFormValue(e.target.value, "code")}
                />
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                <TextField
                    required
                    fullWidth
                    margin={"none"}
                    label={getLocalizedString("profileNameAlt")}
                    value={formData.name}
                    inputProps={{ maxLength: 60 }}
                    onChange={(e) => setFormValue(e.target.value, "name")}
                />
            </Grid>
            <Grid container item alignItems="center" xs={12} style={gridStyleNoHeight}>
                <TextFieldMultiline
                    fullWidth
                    margin={"none"}
                    label={getLocalizedString("profileComments")}
                    value={formData.comment}
                    onChange={(e) => setFormValue(e.target.value, "comment")}
                    rows={4}
                />
            </Grid>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
                <FormControl style={{ width: "100%" }}>
                    <InputLabel shrink id={`label-training`}>
                        {getLocalizedString("trainingSingular")}
                    </InputLabel>
                    <Select
                        displayEmpty
                        value={formData.training}
                        labelId={`label-training`}
                        id={`training`}
                        onChange={(e) => setFormValue(e.target.value, "training")}
                        margin={"none"}
                    >
                        <MenuItem
                            className={"whiteText"}
                            value={""}
                        >
                            {getLocalizedString("noneFemale")}
                        </MenuItem>
                        {
                            trainingList?.map((item) => (
                                <MenuItem
                                    className={"whiteText"}
                                    key={item.key}
                                    value={item.key}
                                >
                                    {item.value}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Grid>
        </StepContainer>
    )
}


export default Header;